import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/air-compressors/reviews")({
  component: () => <ProductHubList hubSlug="air-compressors" variant="reviews" />,
});
